import * as React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { Field, formValueSelector } from 'redux-form';

import type { RootState } from 'af-reducers';

import { SegmentLabel } from '@acceligentllc/storybook';

import Checkbox from 'af-fields/Checkbox';

import DeliverablesSharedForm from 'af-components/SharedForms/Job/Details/Deliverables';

import JobUpsertFM from '../../formModel';
import { formSectionClass, formSectionClassRow } from '../../helpers';
import styles from '../../styles.module.scss';

type OwnProps = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	change: (field: string, value: any) => void;
	formName: string;
};

type Props = OwnProps & ConnectedProps<typeof connector>;

const DeliverableSection: React.FC<Props> = (props) => {
	const { change, isDeliverable } = props;

	const onIsDeliverableClick = React.useCallback(() => {
		change(JobUpsertFM.getAttributeName('deliverableAssigneeId'), null);
		change(JobUpsertFM.getAttributeName('deliverableAssignee'), null);
		change(JobUpsertFM.getAttributeName('deliverableFileFormatId'), null);
		change(JobUpsertFM.getAttributeName('deliverableFileFormat'), null);
		change(JobUpsertFM.getAttributeName('deliverableSoftwareId'), null);
		change(JobUpsertFM.getAttributeName('deliverableSoftware'), null);
		change(JobUpsertFM.getAttributeName('deliverableCodeStandardId'), null);
		change(JobUpsertFM.getAttributeName('deliverableCodeStandard'), null);
		change(JobUpsertFM.getAttributeName('deliverableDeliveryTimelineId'), null);
		change(JobUpsertFM.getAttributeName('deliverableDeliveryTimeline'), null);
		change(JobUpsertFM.getAttributeName('deliverableDeliveryMethodId'), null);
		change(JobUpsertFM.getAttributeName('deliverableDeliveryMethod'), null);
		change(JobUpsertFM.getAttributeName('deliverableNotes'), null);
	}, [change]);

	return (
		<div className={formSectionClass}>
			<SegmentLabel
				label="Deliverables"
				tooltip="Specifications for what's delivered upon job completion — software, format, quality standards, and delivery method. Work orders created from a deliverable job populate the Deliverable table for further management."
			/>
			<div className={[formSectionClassRow, styles['job-form__deliverables']].join(' ')}>
				<Field
					component={Checkbox}
					id="isDeliverable"
					label="Is Deliverable"
					name={JobUpsertFM.getAttributeName('isDeliverable')}
					onValueChange={onIsDeliverableClick}
				/>
			</div>
			{isDeliverable &&
				<DeliverablesSharedForm />}
		</div>
	);
};

function mapStateToProps(state: RootState, props: OwnProps) {
	const { formName } = props;
	const selector = formValueSelector(formName);

	const isDeliverable = selector(
		state,
		JobUpsertFM.getAttributeName('isDeliverable')
	);

	return {
		isDeliverable,
	};
}

const connector = connect(mapStateToProps);

export default connector(DeliverableSection);
